
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-home");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/home/index.js
// module id = E1C8
// module chunks = 6